import {
  ImageCardCta,
  ImageCardCtaProps,
} from '../image-card-cta/image-card-cta';
import { desktop } from '@thrivent/midwest-shared';
import styled from 'styled-components';

const StyledImageCardCta = styled(ImageCardCta)`
  padding-block: 2.5rem 0.25rem;
  ${desktop} {
    padding-block: 5rem 1rem;
    * > img {
      transform: scale(1.1);
      transform-origin: left;
    }
  }
`;

const StyledImageCardCtaWithNBR = styled(StyledImageCardCta)`
  background-color: ${({ theme }) =>
    theme.midwestColors.componentButtonColorBackgroundStrongSecondaryHover};
  ${desktop} {
    padding-block: 3rem;
  }
`;

export const CtaTppSection = (props: ImageCardCtaProps) => {
  return <StyledImageCardCta {...props} />;
};

export const CtaTppSectionWithNBR = (props: ImageCardCtaProps) => {
  return <StyledImageCardCtaWithNBR {...props} />;
};
